import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';
import ConnectPage from './ConnectPage';

export const getLayoutForEntity = () => {
  return {
    containerStyle: { flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center' },
    CustomPageContainer: GenericPageContainer,
    enableComparison: false,
    dataConfig: {},
    widgets: [
      {
        CustomComponent: ConnectPage,
        view: {
          container: {
            style: {
              width: '100%',
              display: 'flex',
              alignItems: 'start'
            }
          }
        }
      }
    ]
  };
};
